<div class="sport-bg"></div>
<div class="sport-bg-overlay"></div>

<div class="row">
    <div class="col-lg-12">
        <div id="sport-form">
            <div class="sport-heading">
                Спортна програма
            </div>

            <ng-container *ngIf="sport">
                <div id="sport-content" [innerHTML]="sport.text"></div>
            </ng-container>
        </div>
    </div>
</div>
